import { writable } from 'svelte/store';
export const FinProBaseUrl = writable(process.env.FinProApiBaseUrl);
export const EliBaseUrl = writable(process.env.EliApiBaseUrl);
export const ImagesUrl = writable(process.env.ImagesUrl);
